const existsClean = (object, key) => {
  return object && object[key] != undefined ? object[key] : '';
};

export { existsClean };
